import { createContext } from "react"
import { Outlet } from "react-router-dom"

type ContextState = {
  getPref: (name: string) => string | undefined
  setPref: (name: string, value: string) => void
}

export const PreferencesContext = createContext<ContextState | undefined>(undefined)

export const PreferencesProvider = ({ children }: { children?: React.ReactNode }) => {
  const value = {
    getPref: (name: string) => {
      return window.localStorage.getItem(name) ?? undefined
    },
    setPref: (name: string, value: string) => {
      window.localStorage.setItem(name, value)
    },
  }

  return <PreferencesContext.Provider value={value}>{children ? children : <Outlet />}</PreferencesContext.Provider>
}
